import React, { useEffect, useState } from "react";
// material
import {
  Box,
  Button,
  Card,
  CardHeader,
  Container,
  Grid,
  Typography
} from "@mui/material";
import { useSelector } from "react-redux";

// components
import Page from "../components/Page";
import {
  StepperPhd,
  StepperPostdoc,
  TableActivityProgressReport
} from "../components/_dashboard/app";
import Comment from "../components/profile/Comment";
import { checkProgressReport } from "../core/service/progressReport.service";
import { createResubmission } from "../core/service/resubmission.service";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

const hrefUploadFormPhD3y = "/upload-formPhd-3y/phd_3y";
const hrefUploadFormPhD5y = "/upload-formPhd-5y/phd_5y";
const hrefUploadFormPostDoc = "/upload-formPostDoc/post_doc";

export default function ResearchProgress() {
  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const [statsResubmission, setStatsResubmission] = useState([
    { require_form: 0, resubmission: 0 }
  ]);
  const { require_form, resubmission } = statsResubmission;
  const { id } = currentUser;

  const getStartResubmission = async (user_id) => {
    const data = await checkProgressReport(user_id);
    setStatsResubmission(data);
  };

  const reqResubmission = async (data) => {
    await createResubmission(data).then(() => {
      Swal.fire({
        icon: "success",
        title: "Resubmission Successfully",
        showConfirmButton: false,
        timer: 1500
      });
    });
  };

  const navigate = useNavigate();
  const pathNext = () =>{
    return navigate(
      role === ROLE_POSTDOC
                          ? hrefUploadFormPostDoc
                          : role === ROLE_PHD_3Y
                          ? hrefUploadFormPhD3y
                          : role === ROLE_PHD_5Y && hrefUploadFormPhD5y
      , { replace: true });
  }
  const pathOutputSubmit = () =>{
    return navigate(
      `/output-submission/${role}`
      , { replace: true });
  }

  useEffect(() => {
    getStartResubmission(id);
  }, []);

  return (
    <Page title="Research progress">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">Research Progress</Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={12}>
            {role === ROLE_POSTDOC ? <StepperPostdoc /> : <StepperPhd />}
          </Grid>

          <Grid item xs={12} md={6} lg={12}>
            <TableActivityProgressReport />
          </Grid>

          <Grid item xs={12} md={6} lg={12}>
            <Card>
              <CardHeader
                title="Research Progress: Upload Form"
                sx={{ textAlign: "justify-center", pt: 6 }}
              />
              <Box sx={{ p: 1, pb: 1 }} dir="ltr">
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  {require_form === 0 ? (
                    <Button
                      variant="contained"
                      size="large"
                      // href={
                      //   role === ROLE_POSTDOC
                      //     ? hrefUploadFormPostDoc
                      //     : role === ROLE_PHD_3Y
                      //     ? hrefUploadFormPhD3y
                      //     : role === ROLE_PHD_5Y && hrefUploadFormPhD5y
                      // }
                      onClick={()=>pathNext()}
                    >
                      Next
                    </Button>
                  ) : resubmission !== 1 ? (
                    <Button
                      variant="contained"
                      size="large"
                      onClick={() => {
                        let data = new FormData();
                        data.append("user_id", id);
                        reqResubmission(data).then(() => {
                          setStatsResubmission({
                            require_form: require_form,
                            resubmission: 0
                          });
                        });
                      }}
                      disabled={resubmission === 0 ? true : false}
                    >
                      Resubmission
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      size="large"
                      // href={
                      //   role === ROLE_POSTDOC
                      //     ? hrefUploadFormPostDoc
                      //     : role === ROLE_PHD_3Y
                      //     ? hrefUploadFormPhD3y
                      //     : role === ROLE_PHD_5Y && hrefUploadFormPhD5y
                      // }
                      onClick={()=>pathNext()}
                    >
                      Next
                    </Button>
                  )}
                </Grid>
              </Box>
            </Card>
          </Grid>

          <Grid item xs={12} md={6} lg={12}>
            <Comment user_id={id} />
          </Grid>

          {(role === ROLE_PHD_3Y || role === ROLE_PHD_5Y) && (
            <Grid item xs={12} md={6} lg={12}>
              <Box sx={{ paddingTop: 3 }}>
                <Button
                  variant="contained"
                  size="large"
                  //href={`/member/output-submission/${role}`}
                  onClick={()=>pathOutputSubmit()}
                >
                  Output submission
                </Button>
              </Box>
            </Grid>
          )}
        </Grid>
      </Container>
    </Page>
  );
}
